/**
 * Accessibilità componenti di terze parti — patch del DOM iniettato.
 *
 * I widget di Yotpo, CMP e Iubenda arrivano via JavaScript dopo il render della
 * pagina, quindi non possiamo correggerli nel Liquid. Qui aspettiamo che compaiano
 * e aggiungiamo/correggiamo il SOLO attributo ARIA mancante — non riscriviamo la
 * loro logica. È una mitigazione: la correzione robusta resta quella a monte del
 * fornitore (ticket aperti). Un MutationObserver ri-applica il fix se il widget
 * viene ri-renderizzato.
 *
 * Copre: NC-05 (Yotpo), NC-04 (CMP), NC-08 parziale (Iubenda aria-modal).
 * NON copre: focus-trap Iubenda, operabilità/live-region Klaviyo, CAPTCHA — vedi ticket.
 */
(function () {
  'use strict';

  /* NC-05 — Yotpo espone `aria-role` (attributo inesistente) invece di `role`. */
  function fixYotpoAriaRole() {
    document.querySelectorAll('[aria-role]').forEach(function (el) {
      var value = el.getAttribute('aria-role');
      if (value && !el.hasAttribute('role')) {
        el.setAttribute('role', value);
      }
      el.removeAttribute('aria-role');
    });
  }

  /* NC-04 — link promozionale A/B (data-cmp-ab) privo di nome accessibile. */
  function fixCmpLinkName() {
    document.querySelectorAll('a[data-cmp-ab]').forEach(function (a) {
      if (a.getAttribute('aria-label') || a.textContent.trim()) return;
      var img = a.querySelector('img[alt]');
      var label =
        a.getAttribute('title') ||
        (img && img.getAttribute('alt').trim()) ||
        'Apri la promozione';
      a.setAttribute('aria-label', label);
    });
  }

  /* NC-08 (parziale) — al banner cookie Iubenda manca aria-modal sul dialog. */
  function fixIubendaModal() {
    document
      .querySelectorAll('[class*="iubenda-cs"] [role="alertdialog"], [id*="iubenda-cs"][role="alertdialog"]')
      .forEach(function (dialog) {
        if (!dialog.hasAttribute('aria-modal')) {
          dialog.setAttribute('aria-modal', 'true');
        }
      });
  }

  function applyFixes() {
    fixYotpoAriaRole();
    fixCmpLinkName();
    fixIubendaModal();
  }

  var scheduled = false;
  function scheduleFixes() {
    if (scheduled) return;
    scheduled = true;
    // I widget arrivano in burst: raggruppiamo le mutazioni in un solo passaggio.
    setTimeout(function () {
      scheduled = false;
      applyFixes();
    }, 200);
  }

  function init() {
    applyFixes();
    if (!('MutationObserver' in window)) return;
    new MutationObserver(scheduleFixes).observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
